<template>
    <section>
        <!-- -->
        <div v-if="getValidationFour" class="mail-verif-wrapper elevation-5">
            <div class="hmi-cross">
                <img src="../../../assets/HMLOGO_WHITE.webp" alt="">
            </div>
            <div class="noti-content-wrapper">
                <div class="mail-svg">
                    <img src="../../../assets/mail-box.svg" alt="">
                </div>
                <div class="noti">
                    <h2>Final step! You're almost there!</h2>

                    <h3 v-if="resendMailMsg">
                        Activation link has been resent, kindly check your email again. Check your spam folder as well to see if the email is there.
                    </h3>
                    <h3 v-else>
                        An activation link is sent to
                        <strong>{{ getValidationFour }}</strong> for verification of your
                        email address and to fully use your account.
                    </h3>
                    <h4>
                        Didn't receive any mail? Check your spam folder or
                        <a
                            class="font-weight-bold"
                            :style="{ color: linkColor }"
                            @click="emailSendingInterval"
                        >
                            <button :disabled="linkDisable">click here</button>
                        </a>
                        to resend your activation link.
                    </h4>
                    <span v-if="linkDisable" style="margin-bottom: 30px;">
                        Please wait for <span style="color: red;">{{ timer }}</span>s before resending the activation link again.
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data: () => ({
        linkColor: 'green',
        linkDisable: false,
        timer: 100
    }),
    computed: {
        ...mapGetters(['getValidationFour', 'mailURL', 'resendMailMsg'])
    },
    methods: {
        ...mapActions(['resendMail']),

        emailSendingInterval() {
            this.linkDisable = true
            this.linkColor = 'gray'
            this.resendMail()

            this.timer = 100
            const interval = setInterval(() => {
                this.timer -= 1
                if(this.timer == 0) {
                    this.linkDisable = false
                    this.linkColor = 'green'
                    clearInterval(interval)
                }
            }, 1000)

            /*
      window.setTimeout(() => {
        this.linkDisable = false;
        this.linkColor = "green";
      }, 1000 * 60);
      */
        }
    }
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/loginBG.webp");
  background-position: center;
  background-size: cover;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 35px;
  padding: 15px 0px;
}
h3 {
  width: 90%;
  margin: auto;
  font-weight: normal;
}
h4 {
  width: 90%;
  margin: auto;
  padding: 20px 0px;
}
/* Main wrapper */
.hmi-cross {
  width: 5%;
  top: 2%;
  left: 1%;
}
.hmi-cross img {
  position: absolute;
  width: 100%;
}
.mail-verif-wrapper {
  position: relative;
  content: "";
  clear: both;
  display: table;
  height: auto;
  background-image: url("../../../assets/mail-bg-wrapper.webp");
  background-size: cover;
  background-position: center;
  background-color: white;
  border-radius: 100px 0px 100px 0px;
}
.mail-svg {
    margin: auto;
    width: 20%;
}
.mail-svg img {
    width: 20%;
}
.noti-content-wrapper {
  margin-top: 0;
  align-items: center;
  text-align: center;
}
.noti {
  margin: auto;
}
@media (max-width: 599px) {
  .mail-verif-wrapper {
    content: "";
    position: relative;
    clear: both;
    display: table;
    width: 90%;
    background-position: left;
    border-radius: 30px 0px 30px 0px;
  }
  .noti-content-wrapper {
    margin-top: 10px;
    width: 100%;
  }
  .noti {
    width: 90%;
  }
  .mail-svg {
    width: 50%;
    margin-top: 20px;
  }
  .mail-svg img {
    width: 30%;
  }
  .hmi-cross {
    position: absolute;
    width: 40%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  h2 {
    font-size: 25px;
  }
  h3 {
    font-size: 18px;
    padding: 15px 0px;
  }
  h4 {
    font-size: 15px;
  }
}
@media (min-width: 599px) and (max-width: 960px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    width: 90%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    position: absolute;
    width: 30%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  .mail-svg {
    margin-top: 20px;
    width: 30%;
  }
  .mail-svg img {
    width: 50%;
  }
  h2 {
    display: block;
    font-size: 35px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    width: 65%;
    background-position: left;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
    width: 100%;
  }
  .noti {
    width: 80%;
  }
  .hmi-cross {
    position: absolute;
    width: 20%;
    left: 5%;
  }
  .hmi-cross img {
    width: 60%;
  }
  .mail-svg {
    margin-top: 5%;
    width: 40%;
  }
  .mail-svg img {
    width: 30%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
@media (min-width: 1264px) {
  .mail-verif-wrapper {
    position: relative;
    content: "";
    clear: both;
    display: table;
    border-radius: 60px 0px 60px 0px;
  }
  .noti-content-wrapper {
  }
  .noti {
  }
  .hmi-cross {
    position: absolute;
    width: 20%;
    left: 5%;
  }
  .hmi-cross img {
    width: 50%;
  }
  .mail-svg {
    margin-top: 5%;
    width: 50%;
  }
  .mail-svg img {
    width: 20%;
  }
  h2 {
    font-size: 40px;
  }
  h3 {
    padding: 15px 0px;
  }
}
</style>
